export const JOYSTICK_RADIUS = 58;
export const JOYSTICK_THUMB_LIMIT = 42;
export const JOYSTICK_DEAD_ZONE = 0.16;

function clampUnit(value) {
  if (!Number.isFinite(value)) {
    return 0;
  }

  return Math.max(-1, Math.min(1, value));
}

export function getJoystickVector(
  origin,
  point,
  {
    radius = JOYSTICK_RADIUS,
    deadZone = JOYSTICK_DEAD_ZONE,
  } = {}
) {
  const rawX = point.x - origin.x;
  const rawY = point.y - origin.y;
  const distance = Math.hypot(rawX, rawY);

  if (!distance || distance / radius < deadZone) {
    return {
      x: 0,
      y: 0,
      thumbX: 0,
      thumbY: 0,
    };
  }

  const clampedDistance = Math.min(distance, radius);
  const scale = clampedDistance / distance;
  const clampedX = rawX * scale;
  const clampedY = rawY * scale;

  return {
    x: clampUnit(clampedX / radius),
    y: clampUnit(clampedY / radius),
    thumbX: (clampedX / radius) * JOYSTICK_THUMB_LIMIT,
    thumbY: (clampedY / radius) * JOYSTICK_THUMB_LIMIT,
  };
}

export function resetJoystickVector() {
  return {
    x: 0,
    y: 0,
    thumbX: 0,
    thumbY: 0,
  };
}
